import React from 'react';

interface ContactSectionProps {
  email: string;
  company: string;
}

export function ContactSection({ email, company }: ContactSectionProps) {
  return (
    <section className="mt-12 border-t pt-8">
      <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
      <p>To resolve a complaint or to request further information regarding the Services, please contact us at:</p>
      <div className="mt-4">
        <p className="font-medium">{company}</p>
        <a 
          href={`mailto:${email}`}
          className="text-green-500 hover:text-green-600 transition-colors"
        >
          {email}
        </a>
      </div>
    </section>
  );
}